/* Talas motion: subtle scroll effects (loaded with `defer` from layout/theme.liquid; CSS lives in assets/talas-design.css, "MOTION" block).
   1. background parallax  - one fixed, aria-hidden layer (faint grid and glow orbs; no illustrations), translate3d only
   2. scroll reveal        - once, staggered 40ms, opacity + transform only. The hidden state (.tm-rv) is added HERE, never in markup or CSS-by-default,
                             so nothing is hidden before this script runs and nothing breaks if it fails. Skips anything already in the first viewport
                             (H1, buy box, hero) so LCP is never delayed, and anything the theme already reveals itself (.tc-reveal, [data-reveal]).
   3. lazy section backgrounds - a decorative span is inserted into a band only when it nears the viewport; fades in with opacity
   3b. photo backgrounds    - model tiles, CTA band, footer: lazy, WebP srcset-style pick, static under reduced motion
   5. header frost         - the theme's glass pill already intensifies on scroll (html.tc-scrolled, talas-chrome.js, now after 40px); the
                             stronger shadow/gradient is carried by .tc-pill::after (opacity only), so no second layer is added here
   prefers-reduced-motion: no parallax, no reveal; layers stay static. Below 768px intensity is halved (travel here, alphas/distances in CSS). */
(function () {
  'use strict';
  if (window.__talasMotion) return;
  window.__talasMotion = true;

  var root = document.documentElement;
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var mqSmall = window.matchMedia('(max-width: 767.98px)');
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }

  /* ---------------------------------------------------------------- 1. parallax scroll handler */
  var layers = {};
  var maxScroll = 1, k = 1, ticking = false, TILE = 96;

  function buildBackground() {
    if (document.querySelector('.tm-bg')) return;
    var bg = el('div', 'tm-bg');
    bg.setAttribute('aria-hidden', 'true');
    bg.innerHTML =
      '<div class="tm-bg__mask"><div class="tm-layer tm-grid" data-tm="grid"></div></div>' +
      '<div class="tm-layer tm-orb tm-o1" data-tm="o1"></div>' +
      '<div class="tm-layer tm-orb tm-o2" data-tm="o2"></div>' +
      '<div class="tm-layer tm-orb tm-o3" data-tm="o3"></div>';
    document.body.insertBefore(bg, document.body.firstChild);
    qa('[data-tm]', bg).forEach(function (n) { layers[n.getAttribute('data-tm')] = n; });
  }

  function measure() {
    maxScroll = Math.max(1, root.scrollHeight - window.innerHeight);
    k = mqSmall.matches ? 0.5 : 1; /* half intensity below 768px */
  }

  function frame() {
    ticking = false;
    var y = window.pageYOffset || root.scrollTop || 0;
    photoParallax();
    if (mqReduce.matches || !layers.grid) return;
    var p = Math.min(1, y / maxScroll), f = function (n) { return n.toFixed(1); };
    layers.grid.style.transform = 'translate3d(0,' + (-((y * 0.18 * k) % TILE)).toFixed(2) + 'px,0)';
    layers.o1.style.transform = 'translate3d(' + f(p * 120 * k) + 'px,' + f(-p * 380 * k) + 'px,0)';
    layers.o2.style.transform = 'translate3d(' + f(-p * 160 * k) + 'px,' + f(-p * 760 * k) + 'px,0)';
    layers.o3.style.transform = 'translate3d(' + f(p * 260 * k) + 'px,' + f(-p * 1300 * k) + 'px,0)';
  }
  function onScroll() { if (!ticking) { ticking = true; raf(frame); } }

  function clearTransforms() { Object.keys(layers).forEach(function (n) { layers[n].style.transform = ''; }); }

  /* ---------------------------------------------------------------- 2. reveal */
  var REVEAL = '.th-model, .th-cat, .th-head, .th-prod__head, .tc-fbrand, .tc-facc, .tsr-list li, .tcol-empty, ' +
               '.cart-section .line-item, .pdx-fits__model, .branch-card, [data-tm-rv]';
  var SKIP_UP = 'h1, .tc-reveal, [data-reveal], .pdx-hero, .product-wrapper, .tc-pill, .tc-mobile, .pdx-lb, .pickup-availability';
  var rvIO = null;

  function armReveal() {
    if (mqReduce.matches || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight;
    var list = qa(REVEAL).filter(function (n) {
      if (n.closest(SKIP_UP)) return false;
      var r = n.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return false;
      return r.top > vh * 0.98; /* first-viewport content is never hidden: no flash, no LCP delay */
    });
    if (!list.length) return;
    rvIO = new IntersectionObserver(function (entries) {
      var i = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var n = en.target;
        n.style.transitionDelay = Math.min(i * 40, 320) + 'ms';
        i++;
        n.addEventListener('transitionend', function done(e) {
          if (e.target !== n || e.propertyName !== 'opacity') return;
          n.removeEventListener('transitionend', done);
          n.classList.remove('tm-rv', 'tm-in'); /* drop the classes so hover transitions are not delayed */
          n.style.transitionDelay = '';
        });
        n.classList.add('tm-in');
        rvIO.unobserve(n);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    list.forEach(function (n) { n.classList.add('tm-rv'); rvIO.observe(n); });
    /* failsafe: whatever is still hidden after 6s is shown (never leave content invisible) */
    setTimeout(function () { qa('.tm-rv:not(.tm-in)').forEach(function (n) { n.classList.add('tm-in'); }); }, 6000);
  }

  /* ---------------------------------------------------------------- 3. lazy section backgrounds */
  var LAZY = [
    ['.th-trust', 'dots'], ['.th-shop', 'mesh'], ['.th-prod', 'lines'], ['.th-cta', 'mesh'],
    ['.tc-footer', 'mesh'], ['.pdx-more', 'dots'], ['.tcol-hero', 'lines']
  ];
  function armLazy() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var s = en.target;
        io.unobserve(s);
        var span = el('span', 'tm-lz tm-lz--' + s.getAttribute('data-tm-lz'));
        span.setAttribute('aria-hidden', 'true');
        s.insertBefore(span, s.firstChild);
        raf(function () { raf(function () { span.classList.add('tm-lz-on'); }); });
      });
    }, { rootMargin: '200px 0px' });
    LAZY.forEach(function (pair) {
      qa(pair[0]).forEach(function (s) {
        if (s.hasAttribute('data-tm-lz')) return;
        s.setAttribute('data-tm-lz', pair[1]);
        s.classList.add('tm-lz-host');
        io.observe(s);
      });
    });
  }

  /* ---------------------------------------------------------------- 3b. lazy photo backgrounds (model tiles, dark CTA band, footer)
     Hosts carry data-tm-bg="url 640, url 1280, url 1920" (talas-bg-photo snippet). Nothing is requested until the host is in / near the
     viewport; the smallest file that covers the host (CSS px x DPR) is chosen; the host keeps a solid dark fallback colour so there is no flash,
     and the photo is an absolutely positioned layer that fades in with opacity, so it can never shift layout. */
  var photoEls = [];
  function pickSrc(host) {
    var parts = (host.getAttribute('data-tm-bg') || '').split(',').map(function (p) {
      var m = p.trim().match(/^(\S+)\s+(\d+)$/); return m ? { u: m[1], w: +m[2] } : null;
    }).filter(Boolean).sort(function (a, b) { return a.w - b.w; });
    if (!parts.length) return '';
    var need = host.getBoundingClientRect().width * Math.min(window.devicePixelRatio || 1, 2);
    for (var i = 0; i < parts.length; i++) if (parts[i].w >= need) return parts[i].u;
    return parts[parts.length - 1].u;
  }
  function armPhotos() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var host = en.target; io.unobserve(host);
        var url = pickSrc(host); if (!url) return;
        var kind = host.getAttribute('data-tm-photo') || 'band';
        var img = new Image();
        img.onload = function () {
          var span = el('span', 'tm-photo tm-photo--' + kind);
          span.setAttribute('aria-hidden', 'true');
          span.style.backgroundImage = (kind === 'tile' ? 'linear-gradient(180deg,rgba(10,16,26,.50) 0%,rgba(10,16,26,.74) 42%,rgba(10,16,26,.93) 100%),' : '') + 'url("' + url + '")';
          host.classList.add('tm-photo-host');
          host.insertBefore(span, host.firstChild);
          photoEls.push({ span: span, host: host, kind: kind });
          raf(function () { raf(function () { span.classList.add('tm-photo-on'); onScroll(); }); });
        };
        img.src = url;
      });
    }, { rootMargin: '120px 0px' });
    qa('[data-tm-bg]').forEach(function (h) { io.observe(h); });
  }
  /* slow parallax for loaded photos: transform only, desktop + motion allowed */
  function photoParallax() {
    if (mqReduce.matches || mqSmall.matches || !mqHover.matches) { photoEls.forEach(function (p) { p.span.style.transform = ''; }); return; }
    var vh = window.innerHeight;
    photoEls.forEach(function (p) {
      var r = p.host.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var d = (r.top + r.height / 2 - vh / 2) * (p.kind === 'tile' ? -0.05 : -0.07);
      p.span.style.transform = 'translate3d(0,' + Math.max(-28, Math.min(28, d)).toFixed(1) + 'px,0)';
    });
  }

  /* ---------------------------------------------------------------- boot */
  function applyReduced() {
    if (mqReduce.matches) { clearTransforms(); qa('.tm-rv').forEach(function (n) { n.classList.remove('tm-rv', 'tm-in'); }); }
    onScroll();
  }
  function bind(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }

  function boot() {
    buildBackground();
    measure();
    armLazy();
    armPhotos();
    armReveal();
    frame();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(function () { measure(); onScroll(); }).observe(document.body);
    bind(mqReduce, applyReduced);
    bind(mqSmall, function () { measure(); onScroll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
